import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import Element, { ElementType } from '@/models/element';
import store from '@/store';

export class BackToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const productCode: string = store.getters.configuration.productPreset.code;
        const body: Element = store.getters.body;
        const legs: Element[] = store.getters.scene.elements.filter(
            (x: Element) => x.type === ElementType.LEGS && x.shaderName !== 'ShaderNPod',
        );
        const hasLegs = legs.length > 0;

        if (
            body.shape.y === 1 &&
            body.shape.x >= 3 &&
            this.depth === 3
        ) {
            const code = 'SPR';
            const dim1 = element.shape.x;
            const dim2 = element.shape.y;
            const color = this.toColor(body);
            const type = this.formatType(code, dim1, dim2);
            return [SimpleSapElement.ELEMENT(type, color)];
        }
        if (
            store.getters.product.isLevelRaiser ||
            ((body.shape.x === 1 || body.shape.y === 1) && hasLegs)
        ) {
            const code = 'STJ';
            const color = this.toColor(body);
            const dim1 = Math.max(element.shape.x, element.shape.y);
            const type = this.formatType(code, dim1, 1);
            return [SimpleSapElement.ELEMENT(type, color)];
        } else if ((body.shape.x === 1 || body.shape.y === 1) && !hasLegs) {
            const code = 'SPP';
            const dim1 = Math.max(element.shape.x, element.shape.y);
            const dim2 = Math.min(element.shape.x, element.shape.y);
            const color = this.toColor(body);
            const type = this.formatType(code, dim1, dim2);
            return [SimpleSapElement.ELEMENT(type, color)];
        } else if (element.shape.x === 1 && (
            element.position.x === 1 ||
            element.position.x === body.shape.x)
        ) {
            const code = 'SPB';
            const dim1 = element.shape.y;
            const dim2 = element.shape.x;
            const color = this.toColor(body);
            const type = this.formatType(code, dim1, dim2);
            return [SimpleSapElement.ELEMENT(type, color)];
        } else if (
            element.shape.x === 2 &&
            body.shape.x === 2
        ) {
            const code = 'STD';
            const dim1 = element.shape.y;
            const dim2 = element.shape.x;
            const color = this.toColor(body);
            const type = this.formatType(code, dim1, dim2);
            return [SimpleSapElement.ELEMENT(type, color)];
        } else if (element.shape.x === 2 && (
            element.position.x === 1.5 ||
            element.position.x === body.shape.x - 0.5)
        ) {
            const code = 'SKB';
            const dim1 = element.shape.y;
            const dim2 = element.shape.x;
            const color = this.toColor(body);
            const type = this.formatType(code, dim1, dim2);
            return [SimpleSapElement.ELEMENT(type, color)];
        } else if (element.shape.x === 2 && !(
            element.position.x === 1.5 ||
            element.position.x === body.shape.x - 0.5)
        ) {
            const code = 'SKW';
            const dim1 = element.shape.y;
            const dim2 = element.shape.x;
            const color = this.toColor(body);
            const type = this.formatType(code, dim1, dim2);
            return [SimpleSapElement.ELEMENT(type, color)];
        }
        return [];
    }
}
